import { TLanguages } from "@languages/languageData";

import { messages as enUS } from "./en-US";
import { messages as es } from "./es";
import { TranslationLegacyMigrationMessages } from "./interfaces";
import { messages as ptBR } from "./pt-BR";

/**
 * Translations of this page, kept inside the feature rather than in the global
 * `languages/` folders: this is a temporary screen, and everything it owns
 * should disappear with its directory.
 */
const MESSAGES: Record<TLanguages, TranslationLegacyMigrationMessages> = {
  "pt-BR": ptBR,
  "en-US": enUS,
  es
};

export const getLegacyMigrationMessages = (
  language: TLanguages
): TranslationLegacyMigrationMessages => MESSAGES[language] ?? ptBR;

export default getLegacyMigrationMessages;
